import { Fragment } from 'react'

export function Stepper({ steps, current }) {
  return (
    <div className="stepper">
      {steps.map((label, idx) => {
        const stepNum = idx + 1
        const state = idx < current ? 'done' : idx === current ? 'active' : 'pending'
        return (
          <Fragment key={idx}>
            <div className={`stepper-item ${state}`}>
              <span className="stepper-circle">{state === 'done' ? '✓' : stepNum}</span>
              <span className="stepper-label">{label}</span>
            </div>
            {idx < steps.length - 1 && <span className="stepper-divider" />}
          </Fragment>
        )
      })}
    </div>
  )
}
